<template>
  <section
    class="slider-area"
    :class="{ 'slider-area_bg-color': !isImage }"
    id="top-section"
  >
    <div class="slider-active">
      <div class="single-slider slider-height2">
        <div class="container">
          <div class="row">
            <div class="col-xl-10 col-lg-11 col-md-12">
              <div class="hero__caption hero__caption2">
                <h1>{{ title }}</h1>
                <breadcrumb :links="breadcrumb" v-if="breadcrumb" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "TopSection",
  components: { Breadcrumb },
  props: {
    title: {
      type: String,
      default: "",
      required: true
    },
    isImage: {
      type: Boolean,
      default: false
    },
    breadcrumb: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped></style>
